export const ChargebacksFilterTabs = {
    Resolved: 'RESOLVED',
    'Not resolved': 'NOTRESOLVED',
    All: 'all'
};
